module.exports = __webpack_public_path__ + "6f586c7fb8f4b9bf221621de0669862d.mp3";